'use strict';

angular.module('amexReconciliationApp')
  .component('purchaseOrderDetailsDataPanel', {
    templateUrl: 'scripts/views/components/purchase-order-details-data-panel.html',
    controller: function ($scope, PurchaseOrderThirdPartyDataRepository, ActiveTransactionModel) {
      var self = this;

      self.$onInit = function () {
        resetState();
        ActiveTransactionModel.onActiveTransactionChanged($scope, fetchThirdPartyData);
      };

      function resetState() {
        self.purchaseOrder = {};
        self.unmatchedAmount = 0;
        self.overage = 0;
        self.loading = true;
        self.hasLinkedData = false;
      }

      function fetchThirdPartyData() {
        var transaction = ActiveTransactionModel.activeTransaction();
        resetState();
        if (transaction) {
          PurchaseOrderThirdPartyDataRepository.getPurchaseOrderThirdPartyData(transaction.id)
            .then(function (data) {
              self.purchaseOrder = data;
              self.loading = false;
              self.hasLinkedData = !_.isEmpty(data);
              self.matchAmount = calculateMatchAmount(transaction);
              calculateDifferenceInAmounts();
            });
        }
      }

      function calculateMatchAmount(transaction) {
        return _.sumBy(transaction.transactionThirdPartyData, 'matchAmount');
      }

      function calculateDifferenceInAmounts() {
        var diff = self.purchaseOrder.orderAmount - self.matchAmount;
        if(diff > 0) {
          self.unmatchedAmount = diff;
        } else if(diff < 0) {
          self.overage = -1 * diff;
        }
      }
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/purchaseOrderDetailsDataPanel.js
// module id = 468
// module chunks = 0